const audiences = [
  {
    icon: "ri-code-box-line",
    title: "Engineering",
    desc: "A single API, no model retraining",
  },
  {
    icon: "ri-scales-3-line",
    title: "Legal",
    desc: "Source-clause traceability per finding",
  },
  {
    icon: "ri-shield-check-line",
    title: "Compliance",
    desc: "Hash-signed audit trail, reproducible",
  },
  {
    icon: "ri-server-line",
    title: "Procurement",
    desc: "Self-hosted, no egress required",
  },
];

export default function TrustStrip() {
  return (
    <section id="trust" className="py-10 md:py-14 bg-background-100 border-y border-background-200/70">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-6 lg:gap-10">
          <p className="text-xs md:text-sm font-semibold tracking-wide uppercase text-secondary-500 whitespace-nowrap lg:shrink-0">
            Who needs this
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6 w-full">
            {audiences.map((item) => (
              <div key={item.title} className="flex items-start gap-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 shrink-0">
                  <i className={`${item.icon} text-lg`} />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{item.title}</p>
                  <p className="text-xs md:text-sm text-foreground-600 mt-0.5">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}